import { handleUnauthorizedResponse } from 'app/apiHelper';
import axios from 'axios';

let AxiosInstance1;

// Create a Promise that resolves after config is loaded and Axios is ready
const axiosInitPromise = fetch("/config/config.json")
  .then((res) => {
    if (!res.ok) throw new Error("Failed to load config.json");
    return res.json();
  })
  .then((config) => {
    window.runtimeConfig = config;

    AxiosInstance1 = axios.create({
      baseURL: config.REACT_APP_BASEURL_ACCESS_CONTROL1,
    });

    AxiosInstance1.interceptors.request.use(
      (config) => {
        const token = sessionStorage.getItem("access_token");
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    AxiosInstance1.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response?.status;
        if (error.response && error.response.status === 401) {
          handleUnauthorizedResponse(error.response);
        } else if (status === 400) {
          
          // ✅ Handle 400 here
          console.warn("Bad Request (400):", error.response.data);
          const message = error.response|| "Invalid input or bad request.";
          error.customMessage = message;
          return message;

          // You can show a user-friendly message, log error, etc.
          // Optional: attach custom message or throw a custom error
          // error.customMessage = "Invalid username or password.";
        }
        return Promise.reject(error);
      }
    );

    return AxiosInstance1;
  });

export default new Proxy({}, {
  get: (_, prop) => {
    if (!AxiosInstance1) {
      throw new Error("AxiosInstance1 not initialized yet. Wait for config to load.");
    }
    return AxiosInstance1[prop];
  }
});

export { axiosInitPromise }